export const ICON_FONT_FAMILY = 'Material Symbols Outlined';
export const ICON_LOAD_TIMEOUT_MS = 5000;
export const ICON_STATE_ATTR = 'data-icons';
/** Ligature probe — default fonts.check() text is a space, which icon fonts often lack. */
export const ICON_PROBE_TEXT = 'menu';

const setIconState = (state) => {
  document.documentElement.setAttribute(ICON_STATE_ATTR, state);
};

const fontSpec = () => `24px "${ICON_FONT_FAMILY}"`;

const isFontAvailable = () => {
  if (!document.fonts?.check) {
    return true;
  }
  return document.fonts.check(fontSpec(), ICON_PROBE_TEXT);
};

const tryMarkReady = () => {
  if (isFontAvailable()) {
    setIconState('ready');
    return true;
  }
  return false;
};

const watchForLateFontLoad = () => {
  if (!document.fonts?.ready) {
    return;
  }

  document.fonts.ready.then(() => {
    tryMarkReady();
  });
};

export const initIcons = () => {
  setIconState('loading');

  if (!document.fonts?.load) {
    setIconState('ready');
    return Promise.resolve();
  }

  const spec = fontSpec();
  let timeoutId;

  // load() success ⇒ faces available. Some Android/Samsung Chromium builds still
  // report check()=false for icon fonts — do not leave icons hidden.
  const loadPromise = document.fonts.load(spec, ICON_PROBE_TEXT).then(() => {
    setIconState('ready');
  });

  const timeoutPromise = new Promise((_, reject) => {
    timeoutId = setTimeout(
      () => reject(new Error('icon font load timeout')),
      ICON_LOAD_TIMEOUT_MS
    );
  });

  return Promise.race([loadPromise, timeoutPromise])
    .catch(() => {
      if (!tryMarkReady()) {
        setIconState('failed');
        watchForLateFontLoad();
      }
    })
    .finally(() => {
      clearTimeout(timeoutId);
    });
};
